import { AnimatePresence, motion } from 'framer-motion';
import { useAdminStore } from '../../store/adminStore';
import DashboardPanel from './panels/DashboardPanel';
import OrdersPanel from './panels/OrdersPanel';
import TransactionsPanel from './panels/TransactionsPanel';
import WalletsPanel from './panels/WalletsPanel';
import SettingsPanel from './panels/SettingsPanel';
import './PanelContainer.css';

export default function PanelContainer() {
    const activePanel = useAdminStore(state => state.activePanel);

    return (
        <div className="panel-container">
            <AnimatePresence mode="wait">
                <motion.div
                    key={activePanel}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.3 }}
                    className="panel-content"
                >
                    {activePanel === 'dashboard' && <DashboardPanel />}
                    {activePanel === 'orders' && <OrdersPanel />}
                    {activePanel === 'transactions' && <TransactionsPanel />}
                    {activePanel === 'wallets' && <WalletsPanel />}
                    {activePanel === 'settings' && <SettingsPanel />}
                </motion.div>
            </AnimatePresence>
        </div>
    );
}
